var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHodboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39342",
    "data-name": "Group 39342",
    transform: "translate(-954 -3484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1302",
    "data-name": "Ellipse 1302",
    transform: "translate(954 3484)",
    fill: "#fff",
    stroke: "#7042c1",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "receptionist-icon",
    transform: "translate(961.289 3490.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68469",
    "data-name": "Path 68469",
    d: "M5.107,2.44a.312.312,0,0,0-.166.044.126.126,0,0,0-.047.055.189.189,0,0,0-.015.089.782.782,0,0,0,.157.383v0l.329.524a2.791,2.791,0,0,0,.443.582.91.91,0,0,0,.633.255.933.933,0,0,0,.669-.266,2.939,2.939,0,0,0,.456-.622l.372-.612a.6.6,0,0,0,.079-.326c-.009-.037-.05-.055-.119-.059a.285.285,0,0,0-.045,0,.4.4,0,0,0-.052,0,.075.075,0,0,1-.028,0,.423.423,0,0,1-.1-.006L7.8,1.922c-.943.149-1.649-.553-2.647-.14l.072.663a.737.737,0,0,1-.117,0Zm1.168,8.288a.894.894,0,1,1-.894.894.894.894,0,0,1,.894-.894ZM1.387,7.483a.318.318,0,0,1-.047,0,.306.306,0,0,1-.047,0H.64a.041.041,0,0,0-.021.006l0,.006A.038.038,0,0,0,.6,7.521V8.983A.041.041,0,0,0,.608,9l0,0a.038.038,0,0,0,.026.012h.81a.236.236,0,0,1,.041,0l.041,0h9.508a.236.236,0,0,1,.041,0l.041,0h.661a.036.036,0,0,0,.038-.038V7.521a.041.041,0,0,0-.038-.038Zm1.534-.6a.5.5,0,0,1-.019-.1c.012-.922-.13-1.094.842-1.636.355-.2,1.273-.266,1.673-.528a3.475,3.475,0,0,0,.17-.444l0-.012a3.6,3.6,0,0,1-.383-.528l-.329-.524a.955.955,0,0,1-.187-.479.379.379,0,0,1,.032-.171.319.319,0,0,1,.113-.131.4.4,0,0,1,.08-.041A8.3,8.3,0,0,1,4.9,1.347a1.36,1.36,0,0,1,.04-.214A1.382,1.382,0,0,1,5.857.245c.205-.071.126-.24.334-.229A2.67,2.67,0,0,1,7.734.7a2.177,2.177,0,0,1,.289,1.627h0A.24.24,0,0,1,8.2,2.5a.744.744,0,0,1-.091.45h0a.048.048,0,0,1-.006.011l-.375.619a3.062,3.062,0,0,1-.488.661l-.009.009.06.089c.065.1.139.2.208.289.408.254,1.307.322,1.658.518.894.5.673.765.737,1.636a.481.481,0,0,1-.019.1h1.911a.641.641,0,0,1,.64.64V8.984a.636.636,0,0,1-.188.451h0a.636.636,0,0,1-.451.188h-.4v4.412a.488.488,0,0,1-.486.486H1.674a.485.485,0,0,1-.345-.143.246.246,0,0,1-.024-.026.483.483,0,0,1-.119-.319V9.623H.64a.639.639,0,0,1-.452-.188.181.181,0,0,1-.02-.022A.635.635,0,0,1,0,8.983V7.521a.639.639,0,0,1,.188-.452l.024-.021A.635.635,0,0,1,.64,6.881ZM1.792,9.623v4.295H10.78V9.623ZM5.771,5.2a.408.408,0,0,1,0-.6,1.77,1.77,0,0,1,.575.264.262.262,0,0,1,.125-.02,4.138,4.138,0,0,1,.62-.28.39.39,0,0,1-.022.659,1.686,1.686,0,0,1-.383-.139.436.436,0,0,1-.026.1l.266,1.262A5.536,5.536,0,0,0,7.392,4.8a3.528,3.528,0,0,1-.263-.357l-.052-.077a1.1,1.1,0,0,1-.635.187,1.071,1.071,0,0,1-.694-.249,2.164,2.164,0,0,1-.2.471.152.152,0,0,1-.019.02,6.973,6.973,0,0,0,.5,1.656l.266-1.262a.305.305,0,0,1-.052-.169,1.557,1.557,0,0,1-.465.178Z",
    transform: "translate(0 0)",
    fill: "#7042c1",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHodboxIcon);
export default __webpack_public_path__ + "static/media/hodboxIcon.8d6f951cc98c7121eb6bc4d6b32e10f8.svg";
export { ForwardRef as ReactComponent };